export var AgentDepositStatusType;
(function (AgentDepositStatusType) {
    AgentDepositStatusType[AgentDepositStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AgentDepositStatusType[AgentDepositStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    AgentDepositStatusType[AgentDepositStatusType["FAIL"] = 3] = "FAIL";
})(AgentDepositStatusType || (AgentDepositStatusType = {}));
//# sourceMappingURL=AgentDepositStatusType.js.map